const routes = {
  login: 'auth/login',
  changePassword: 'auth/change-password',
  forgotPassword: 'auth/forgot-password',
  resetPassword: 'auth/reset-password/',
};

export default routes